import { Button, Placement, Tooltip } from '@aus-platform/design-system';
import classname from 'classnames';
import { isNil } from 'lodash';
import { selectMap3dDataset } from 'map-3d/shared/map-3d-slices';
import type { HTMLProps } from 'react';
import React, { useState } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { SelectTerrainModal } from '../modals/select-terrain-modal';

export const Map3DNoTerrainSelected: React.FC<HTMLProps<HTMLDivElement>> = ({
  className,
}) => {
  // States.
  const { selectedProject } = useAppSelector(selectMap3dDataset);
  const [showModals, setShowModals] = useState({
    selectTerrainModal: false,
  });

  // Modal Handlers.
  const showSelectTerrainModal = () =>
    setShowModals((prevShowModals) => ({
      ...prevShowModals,
      selectTerrainModal: true,
    }));

  const hideSelectTerrainModal = () =>
    setShowModals((prevShowModals) => ({
      ...prevShowModals,
      selectTerrainModal: false,
    }));

  // Constants.
  const customClassName = classname(['map-3d-no-terrain-container', className]);

  // Variables.
  const isButtonDisabled = isNil(selectedProject);

  return (
    <div className={customClassName}>
      <span className="map-3d-no-terrain-container__text">
        No terrain selected
      </span>
      <Tooltip
        placement={Placement.Bottom}
        hoverText="Please select a project to enable terrain selection."
        className="map-3d-no-terrain-container__tooltip"
        activeState={!isButtonDisabled}
      >
        <Button onClick={showSelectTerrainModal} disabled={isButtonDisabled}>
          Select Terrain
        </Button>
      </Tooltip>

      {showModals.selectTerrainModal && (
        <SelectTerrainModal onHide={hideSelectTerrainModal} />
      )}
    </div>
  );
};
